import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const links = [
  { id: "about", label: "About Me" },
  { id: "projects", label: "Portfolio" },
  { id: "process", label: "Services" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const goTo = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const goHome = (e) => {
    e.preventDefault();
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      return;
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <header className="sticky top-0 z-50 w-full border-b border-ink/10 bg-white/80 backdrop-blur-md">
        <nav className="site-wrap flex h-16 items-center justify-between">
          <a href="#home" onClick={goHome} className="text-sm font-medium tracking-wide">
            LC
          </a>

          <ul className="hidden items-center gap-8 text-[13px] text-ink/80 md:flex">
            {links.map((link) => (
              <li key={link.id}>
                <button
                  type="button"
                  onClick={() => goTo(link.id)}
                  className="transition hover:text-ink"
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>

          <button
            type="button"
            onClick={() => goTo("contact")}
            className="btn-line hidden md:inline-flex"
          >
            Book A Call ↗
          </button>

          <button
            type="button"
            className="relative z-50 flex h-10 w-10 items-center justify-center md:hidden"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <span className="relative block h-3 w-6">
              <span
                className={`absolute left-0 h-px w-6 bg-ink transition ${
                  open ? "top-1.5 rotate-45" : "top-0"
                }`}
              />
              <span
                className={`absolute left-0 h-px w-6 bg-ink transition ${
                  open ? "top-1.5 -rotate-45" : "bottom-0"
                }`}
              />
            </span>
          </button>
        </nav>
      </header>

      {open ? (
        <div className="fixed inset-0 z-40 bg-white pt-24 md:hidden">
          <ul className="site-wrap flex flex-col gap-6">
            {links.map((link) => (
              <li key={link.id}>
                <button
                  type="button"
                  onClick={() => goTo(link.id)}
                  className="text-3xl font-light"
                >
                  {link.label}
                </button>
              </li>
            ))}
            <li>
              <button type="button" onClick={() => goTo("contact")} className="text-3xl font-light">
                Book A Call
              </button>
            </li>
          </ul>
        </div>
      ) : null}
    </>
  );
};

export default Header;
